import { cva } from "class-variance-authority"

export const selectFieldVariants = cva(
  `group font-medium-525 text-general-primary-text relative m-px inline-block w-[8.25rem] rounded`,
  {
    variants: {
      error: {
        true: "outline-general-red outline outline-1 focus-within:outline-hidden",
      },
      success: {
        true: "outline-general-green outline outline-1 focus-within:outline-hidden",
      },
    },
  }
)

// defining this for the sake of selectSizeKeys below
const size = {
  default: "",
  narrow: "",
}
export const selectSizeKeys = Object.keys(size)

export const selectTriggerVariants = cva(
  `bg-input-field-dropdown-primary disabled:text-icon-general-disabled inline-flex w-full items-center justify-between rounded p-2 pl-3 focus-within:outline-2 focus-visible:outline-2 disabled:cursor-not-allowed`,
  {
    variants: {
      size: {
        default: "h-10",
        narrow: "h-8 p-1 px-2 focus-within:outline-1 focus-visible:outline-1",
      },
      v2: {
        true: `bg-interaction-field group-data-[disabled=true]:bg-button-inactive focus-within:bg-interaction-field-selected focus-within:text-icon-general-primary focus-within:outline-semantic-interaction-focused hover:bg-interaction-field-hovered focus-visible:bg-interaction-field-selected focus-visible:text-icon-general-primary focus-visible:outline-semantic-interaction-focused outline-offset-0 transition-colors focus-within:outline-1 focus-visible:outline-1`,
      },
    },
  }
)

export const selectOptionVariants = cva(
  "font-medium-525 text-general-primary-text cursor-pointer",
  {
    variants: {
      size: {
        default: "p-2 pl-3",
        narrow: "h-8 p-1",
      },
      v2: {
        true: [
          "bg-interaction-item aria-selected:bg-interaction-item-hovered data-[highlighted='true']:bg-interaction-item-hovered data-[kb-highlighted='true']:border-semantic-interaction-selected flex items-center justify-between gap-2 border border-transparent first:border-t-transparent",
          "border-t-general-neutral-02",
        ],
        false:
          "odd:bg-input-field-dropdown-secondary even:bg-input-field-dropdown-primary data-[highlighted='true']:text-general-static-white-text data-[highlighted='true']:bg-blue-500",
      },
      // only used in compoundVariants
      multiselect: {
        true: "",
        false: "",
      },
    },
    defaultVariants: {
      size: "default",
      v2: false,
      multiselect: false,
    },
    compoundVariants: [
      {
        multiselect: false,
        size: "narrow",
        className: "px-1.5",
      },
    ],
  }
)
